import React from 'react'
import { Container, ContainerInterno, TituloPrincipal, Subtitulo, ListaConteudos, ListaConteudosItem, ValorAte, Porcentagem, Legenda} from './Styled'

export default function DescontoProporcional () {

    return (
        <Container>
            <ContainerInterno>

                {/* Título Principal */}
                <TituloPrincipal>Seu desconto é <strong>proporcional</strong> à sua<br /> dedicação</TituloPrincipal>

                {/* Subtítulo */}
                <Subtitulo>Quanto mais você já investiu na sua preparação (compras até 30/05), maior<br /> o seu desconto exclusivo de aluno.</Subtitulo>

                {/* Lista Conteúdos */}
                <ListaConteudos>

                    {/* Item 1 */}
                    <ListaConteudosItem>
                        <ValorAte>Até R$ 1.000</ValorAte>
                        <Porcentagem>+10%</Porcentagem>
                        <Legenda>de desconto extra</Legenda>
                    </ListaConteudosItem>

                    {/* Item 1 */}
                    <ListaConteudosItem>
                        <ValorAte>R$ 1.001 a R$ 2.000</ValorAte>
                        <Porcentagem>+15%</Porcentagem>
                        <Legenda>de desconto extra</Legenda>
                    </ListaConteudosItem>

                    {/* Item 3 */}
                    <ListaConteudosItem>
                        <ValorAte>R$ 2.001 a R$ 3.000</ValorAte>
                        <Porcentagem>+20%</Porcentagem>
                        <Legenda>de desconto extra</Legenda>
                    </ListaConteudosItem>

                    {/* Item 4 */}
                    <ListaConteudosItem className={'lastItem'}>
                        <ValorAte>Acima de R$ 3.000</ValorAte>
                        <Porcentagem>+25%</Porcentagem>
                        <Legenda>de desconto extra</Legenda>
                    </ListaConteudosItem>

                </ListaConteudos>

            </ContainerInterno>
        </Container>
    )
}
